import { defineMessages } from '@jutro/locale';

export default defineMessages({
    policyInformation: {
        id: 'quoteandbind.ho.views.policy-info.Policy Info',
        defaultMessage: 'Policy Information'
    },
    coverageStartDate: {
        id: 'quoteandbind.ho.views.policy-info.Coverage Start Date',
        defaultMessage: 'Coverage Start Date'
    },
    primaryInsured: {
        id: 'quoteandbind.ho.views.policy-info.Primary Insured',
        defaultMessage: 'Primary Insured'
    },
    address: {
        id: 'quoteandbind.ho.views.policy-info.Address',
        defaultMessage: 'Address'
    },
    sameBillingAddress: {
        id: 'quoteandbind.ho.views.policy-info.Is the Billing Address the same as the above address?',
        defaultMessage: 'Is the Billing Address the same as the above address?'
    },
    email: {
        id: 'quoteandbind.ho.views.policy-info.Email',
        defaultMessage: 'Email'
    },
    phone: {
        id: 'quoteandbind.ho.views.policy-info.Phone',
        defaultMessage: 'Phone'
    },
    coverages: {
        id: 'quoteandbind.ho.views.policy-info.Your Coverages',
        defaultMessage: 'Coverages'
    }
});
